import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PhysicalProgress from 'components/progress/PhysicalProgress';
import PillTabs from 'components/shared/tabs/PillTabs';
import SessionProgressContent from 'components/session/SessionProgressContent';
import SEOPageTitle from 'components/shared/SEOPageTitle';
import AppBarContext from 'context/AppBarContext';

function ProgressHistory() {
  const { t } = useTranslation(['routes', 'sessions']);
  const pageTitle = t('progress.myProgress', { ns: 'routes' });
  const { setAppBarButton, setAppBarTitle } = useContext(AppBarContext);
  // OTRIX Play sin sesiones 1:1 → SOLO progreso Físico (sin toggle inhundible). Si un plan
  // adicional (pilates) otorga sesiones 1:1, se muestran ambos como a cualquier cliente.
  const isOtrixPlay = useSelector((state) => state.auth.user?.platform) === 'otrix_play';
  const hasOneOnOne = useSelector((state) => Boolean(state.auth.user?.has_one_on_one_sessions));
  const physicalOnly = isOtrixPlay && !hasOneOnOne;
  // "Ver mi progreso completo" llega aquí esperando el progreso de SESIONES → default
  // (salvo cuando solo aplica Físico).
  // 0 = Sesiones, 1 = Físico. PillTabs indexa por posición, como el resto de las pestañas.
  const [tab, setTab] = useState(physicalOnly ? 1 : 0);

  useEffect(() => {
    setAppBarButton(null);
    setAppBarTitle(pageTitle);
  }, [pageTitle, setAppBarButton, setAppBarTitle]);

  return (
    <>
      <SEOPageTitle title={pageTitle} />
      {/* Progresos = progreso FÍSICO (fotos). El resumen/donut de rendimiento Play vive en
          Rendimientos y Mi Rango; aquí duplicaba métricas y ensuciaba la pantalla. */}
      {!physicalOnly && (
        <PillTabs
          value={tab}
          onChange={(_, next) => setTab(next)}
          ariaLabel={pageTitle}
          sx={{ mb: 3 }}
          tabs={[
            { key: 'sessions', label: t('sessionsProgress', { ns: 'sessions', defaultValue: 'Sesiones' }) },
            { key: 'physical', label: t('physicalProgress', { ns: 'sessions', defaultValue: 'Físico' }) }
          ]}
        />
      )}

      {physicalOnly || tab === 1 ? <PhysicalProgress /> : <SessionProgressContent />}
    </>
  );
}

export default ProgressHistory;
